<template>
    <PageView>
        <a-spin :spinning="loading">
            <a-card title="账户设置">
                <a-form :form="form" style="width:700px">
                    <a-form-item label="登录账号" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="!uid">
                        <a-input
                            v-decorator="['loginname', { rules: [{ required: true, message: '请输入登录账号' }] }]"
                            placeholder="请输入登录账号"
                        />
                    </a-form-item>
                    <a-form-item label="密码" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            type="password"
                            v-decorator="['loginpwd', { rules: [{ required: true, message: '请输入密码' }] }]"
                            placeholder="请输入密码"
                        />
                    </a-form-item>
                    <a-form-item label="重复密码" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            type="password"
                            v-decorator="['loginpass', { rules: [{ required: true, message: '请输入重复密码' }] }]"
                            placeholder="请输入重复密码"
                        />
                    </a-form-item>
                </a-form>
                <a-button type="primary" @click="sub">
                    修改
                </a-button>
                <a-button type="primary" @click="$router.back()" style="margin-left:10px">
                    返回
                </a-button>
            </a-card>
        </a-spin>
    </PageView>
</template>
<script type="text/jsx">
import moment from 'moment'
import Shop from '../../api/Shop.js'
import Home from '../../api/Home.js'
export default {
    name: 'addMember',
    data () {
        return {
            form:this.$form.createForm(this),
            loading: true,
            uid: undefined,
            labelCol: {
                 xs: { span: 2 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 }
            },
            addone: [],
            addtwo: [],
            addthree: [],
            searchData: {
                pro_id: undefined,
                city_id: undefined,
                area_id: undefined,
            },
            pic: '',
            uid:this.$route.query.id || undefined
        }
    },
    activated () {
        this.loading = false
        // Shop.AreaList({
        //     parent_id: 100000
        // }).then(res => {
        //     this.addone = res.result
        //     this.loading = false
        //     this.form.resetFields()
        //     this.searchData.pro_id = undefined
        //     this.searchData.city_id = undefined
        //     this.searchData.area_id = undefined
        //     this.uid = this.$route.query.id || undefined
        //     if(this.uid)this.getPerson()
        // })
    },

    methods: {
        moment,
        handleChange (e) {
            let file = e.target.files[0]
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    this.pic = res.result
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },
        getaddone (id) {
            Shop.AreaList({
                parent_id: id
            }).then(res => {
                this.addtwo = res.result
            })
        },
        getaddtwo (id) {
            Shop.AreaList({
                parent_id: id
            }).then(res => {
                this.addthree = res.result
            })
        },
        // 修改用
        getPerson () {
            this.loading = true
            Shop.FindShop({ id: this.uid }).then(res => {
                let data = res.result
                this.$nextTick(() => {
                    this.form.setFieldsValue({
                       'bili': data.bili,
                       'add_ress': data.add_ress,
                       'name': data.name,
                       'phone': data.phone,
                       'loginpwd': data.pass,
                       'loginpass': data.pass,
                    })
                    this.searchData.pro_id = data.pro_id.toString()
                    this.getaddone(this.searchData.pro_id)
                    this.searchData.city_id = data.city_id.toString()
                    this.getaddtwo(this.searchData.city_id)
                    this.searchData.area_id = data.area_id.toString()
                    this.loading = false
                })
            })
        },
        sub () {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true
                    if(this.uid){
                      Shop.SaveShop({ id:this.uid,...values, ...this.searchData }).then(res => {
                        this.loading = false

                        this.$router.back()
                        this.form.resetFields()
                      }).catch(res => {
                          this.loading = false
                      })
                    }else{
                      Shop.AddShop({ ...values, ...this.searchData }).then(res => {
                        this.loading = false
                        this.$router.back()
                        this.form.resetFields()
                      }).catch(res => {
                          this.loading = false
                      })
                    }
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.imgContaienr {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }
    }
}

.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}

.map {
    width: 900px;
    height: 500px;
}

#tip {
    background-color: #fff;
    border: 1px solid #ccc;
    padding-left: 10px;
    padding-right: 2px;
    position: absolute;
    min-height: 65px;
    top: 10px;
    font-size: 12px;
    right: 10px;
    border-radius: 3px;
    overflow: hidden;
    line-height: 20px;
    min-width: 30%;
}

#tip input[type='button'] {
    background-color: #0d9bf2;
    height: 25px;
    width: 500px;
    text-align: center;
    line-height: 25px;
    color: #fff;
    font-size: 12px;
    border-radius: 3px;
    outline: none;
    border: 0;
    cursor: pointer;
}

#tip input[type='text'] {
    height: 25px;
    border: 1px solid #ccc;
    padding-left: 5px;
    border-radius: 3px;
    outline: none;
}
</style>
